import React from 'react';
import { Link } from 'react-router-dom';
// Types
import { UserProps } from 'types/user';
// Utils
import { validArray } from 'utils';
// Elements
import Badge from 'elements/Badge';
import DateRange from 'elements/DateRange';
import { ListItem } from 'elements/ListItems';
import { LoadingContent } from 'elements/Loading';
// Style
import styles from './style/userCard.module.css';


interface UserCardProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultOrganisation?: any,
  href?: string,
  loading?: boolean,
  status?: boolean,
  user?: UserProps,
}

function UserCard({
  defaultOrganisation,
  href,
  loading,
  status,
  user,
}:UserCardProps) {
  const {
    endDate,
    firstName,
    lastLoggedIn,
    lastName,
    userId,
    organisations,
    startDate,
  } = user || {};  

  return (
    <Link to={href || ''}>
      <div className={`${styles.container} ${loading ? styles.container_loading : ''}`}>
        { loading ? (
          <section className={styles.loading}>
            <LoadingContent loading />
          </section>
        ) : (
          <section className={styles.content}>
            <div className={styles.status}>
              { status ? (
                <Badge badgeStyle="success" label="Active" />
              ) : (
                <Badge badgeStyle="error" label="Inactive" />
              )}
            </div>
            <h3 className="display6">{`${firstName} ${lastName}`}</h3>
            <p>{userId}</p>
            <DateRange
              startDate={startDate && startDate.split('-').join(' ')}
              endDate={endDate ? endDate.split('-').join(' ') : '-'}
            />
            <div className={styles.details}>
              <ListItem>
                <span>Organisations</span>
                <strong>
                  {organisations && validArray(organisations) ? organisations.map((organisation, i) => (
                    <span key={organisation.orgRef}>{`${organisation.orgDescription}${i < organisations.length - 1 ? ', ' : ''}`}</span>
                  )) : (
                    <span>-</span>
                  )}
                </strong>
              </ListItem>
              <ListItem>
                <span>Last Login</span>
                <strong>
                  { lastLoggedIn ? lastLoggedIn.split('-').join(' ') : '-' }
                </strong>
              </ListItem>
            </div>
          </section>
        )}
      </div>
    </Link>
  );
}

UserCard.defaultProps = {
  defaultOrganisation: {},
  href: '',
  loading: false,
  status: false,
  user: {},
}

export default UserCard;
